interface IErrorPayload {
  message?: string;
  messageCode?: string;
  reasons?: string[];
  errors?: Record<string, unknown>;
  recoverable_until?: string | null;
  detail?: string;
  invitation_id?: number;
  invited_user_type?: unknown;
  invitation_type?: unknown;
  data?: unknown;
}

export class NetworkError {
  public code: number;
  public description: string;
  public errorPayload: IErrorPayload;

  constructor(
    code: number,
    description: string,
    errorPayload: IErrorPayload,
    public readonly retryAfterSeconds: number | null = null
  ) {
    this.code = code;
    this.description = description;
    this.errorPayload = errorPayload;
  }
}

export function parseRetryAfter(value: string | null, now = Date.now()): number | null {
  if (!value?.trim()) return null;
  if (/^\d+$/.test(value.trim())) {
    const seconds = Number(value);
    return Number.isSafeInteger(seconds) ? seconds : null;
  }
  // Retry-After may also contain an HTTP date.
  if (!/[a-z]/i.test(value)) return null;
  const timestamp = Date.parse(value);
  return Number.isFinite(timestamp) ? Math.max(0, Math.ceil((timestamp - now) / 1000)) : null;
}
